import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { BUSINESS } from "@/lib/legal";

const sections = [
  {
    id: "titular",
    title: "Datos identificativos del titular",
    content: (
      <>
        <p>
          En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información
          y de Comercio Electrónico (LSSI-CE), se informa de que el titular de este sitio web y de la aplicación instalable es:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li><strong>Titular:</strong> <span className="notranslate">{BUSINESS.name}</span></li>
          <li><strong>NIF:</strong> <span className="notranslate">{BUSINESS.nif}</span></li>
          <li><strong>Domicilio:</strong> {BUSINESS.address}</li>
          <li><strong>Correo electrónico:</strong> {BUSINESS.email}</li>
          <li><strong>Teléfono:</strong> {BUSINESS.phone}</li>
          <li><strong>Sitio web:</strong> <span className="notranslate">{BUSINESS.domain}</span></li>
        </ul>
      </>
    ),
  },
  {
    id: "objeto",
    title: "Objeto y ámbito de aplicación",
    content: (
      <p>
        El presente Aviso Legal regula el acceso, la navegación y el uso del sitio web y de la aplicación de{" "}
        <span className="notranslate">{BUSINESS.name}</span>, a través de los cuales se ofrece información sobre nuestros
        servicios de lavandería (autoservicio en tienda, lavado, secado, planchado y recogida a domicilio), la reserva y el
        pago online de dichos servicios, el seguimiento de pedidos y la publicación de opiniones. El acceso al sitio atribuye la
        condición de usuario e implica la aceptación plena de este Aviso Legal, de la{" "}
        <Link to="/privacidad" className="text-cyan-700 underline underline-offset-2">Política de privacidad</Link>, de la{" "}
        <Link to="/cookies" className="text-cyan-700 underline underline-offset-2">Política de cookies</Link> y, en caso de contratar,
        de las <Link to="/condiciones" className="text-cyan-700 underline underline-offset-2">Condiciones del servicio</Link>.
      </p>
    ),
  },
  {
    id: "uso",
    title: "Condiciones de uso",
    content: (
      <>
        <p>El usuario se compromete a hacer un uso adecuado y lícito del sitio web, y en particular a:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Facilitar datos veraces y actualizados en los formularios de reserva, contacto, cuenta de cliente y opiniones.</li>
          <li>No publicar opiniones falsas, ofensivas, difamatorias o que vulneren derechos de terceros.</li>
          <li>No introducir virus ni realizar acciones que puedan dañar, inutilizar o sobrecargar el sitio o sus servicios.</li>
          <li>No utilizar el sitio para fines contrarios a la ley, la moral o el orden público.</li>
        </ul>
        <p>
          <span className="notranslate">{BUSINESS.name}</span> se reserva el derecho de retirar las opiniones que incumplan estas
          normas y de denegar el acceso a los usuarios que hagan un uso indebido del sitio.
        </p>
      </>
    ),
  },
  {
    id: "propiedad",
    title: "Propiedad intelectual e industrial",
    content: (
      <p>
        Todos los contenidos del sitio (textos, imágenes, logotipos, diseño, código fuente, etc.) son titularidad de{" "}
        <span className="notranslate">{BUSINESS.name}</span> o de terceros que han autorizado su uso, y están protegidos por la
        legislación de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución, comunicación pública o
        transformación sin autorización expresa, salvo para uso personal y privado.
      </p>
    ),
  },
  {
    id: "responsabilidad",
    title: "Exclusión de responsabilidad",
    content: (
      <>
        <p>
          <span className="notranslate">{BUSINESS.name}</span> procura que la información publicada sea veraz y esté actualizada,
          pero no garantiza la ausencia de errores ni la disponibilidad ininterrumpida del sitio, y no se hace responsable de los
          daños derivados de interrupciones, virus o fallos ajenos a su control.
        </p>
        <p>
          Los precios de los servicios en tienda mostrados en la web son orientativos y pueden variar; prevalecerán en todo caso
          los indicados en el establecimiento. Los precios de los servicios online se confirman en el momento del pago. El coste de
          desplazamiento se calcula de forma automática a partir de la distancia por carretera entre el local y la dirección
          indicada por el cliente, utilizando servicios cartográficos de terceros (OpenStreetMap), por lo que puede presentar
          pequeñas diferencias respecto a la distancia real.
        </p>
      </>
    ),
  },
  {
    id: "terceros",
    title: "Enlaces y servicios de terceros",
    content: (
      <p>
        El sitio integra servicios de terceros: Stripe (pago seguro con tarjeta), Google (inicio de sesión, mapa de ubicación,
        traducción automática y publicidad con Google AdSense), WhatsApp (contacto directo) y OpenStreetMap/OSRM (cálculo de distancias). Dichos servicios se rigen
        por sus propias condiciones y políticas de privacidad, de las que <span className="notranslate">{BUSINESS.name}</span> no
        es responsable. La traducción automática es un servicio de cortesía; en caso de discrepancia prevalece la versión en español.
      </p>
    ),
  },
  {
    id: "legislacion",
    title: "Legislación aplicable y jurisdicción",
    content: (
      <>
        <p>
          Este Aviso Legal se rige por la legislación española. Para la resolución de cualquier controversia, las partes se someten,
          cuando la normativa de consumo lo permita, a los Juzgados y Tribunales de Zaragoza. Si el usuario tiene la condición de
          consumidor, podrá acudir a los tribunales de su domicilio.
        </p>
        <p>
          Asimismo, se informa de que la Comisión Europea pone a disposición de los consumidores una plataforma de resolución de
          litigios en línea en{" "}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-cyan-700 underline underline-offset-2">
            ec.europa.eu/consumers/odr
          </a>. Disponemos de hojas de reclamaciones a disposición de los clientes en el establecimiento.
        </p>
      </>
    ),
  },
];

export default function AvisoLegal() {
  return (
    <LegalLayout
      testId="legal-aviso-page"
      title="Aviso legal"
      subtitle="Información general sobre el titular de este sitio web y las condiciones de acceso y uso."
      sections={sections}
    />
  );
}
